import { useCallback, useState } from 'react';
import _ from 'underscore';
import { useAccount } from '@bingads-webui/overreact-cc';
import { usePromisify } from '@bingads-webui-react/overreact';
import {
  useAccountLevelVariables,
  usePostponeReadVariables,
} from '@bingads-webui-campaign-react/basic-context-utils';

export const useLoadAndUpdateAccountBusinessInfo = () => {
  const accountLevelVariables = useAccountLevelVariables();
  const postponeReadConfig = usePostponeReadVariables();
  const [, { read: readAccount, update: updateAccount }] = useAccount(accountLevelVariables, postponeReadConfig);
  const [
    readAccountAsync, updateAccountAsync,
  ] = usePromisify([readAccount, updateAccount]);
  const [accountData, setAccountData] = useState({});

  const loadAccountContactInfo = useCallback(() => readAccountAsync({}).then((account) => {
    const businessName = _.get(account, ['Name'], '');
    const accountId = _.get(account, ['id'], '');

    const accountInfo = {
      businessName,
      accountId,
      isValid: true,
    };

    setAccountData(account);
    return accountInfo;
  }), [readAccountAsync]);

  const updateAccountContactInfo = useCallback((contactInfo = {}) => {
    if (_.isEmpty(contactInfo)) {
      return Promise.resolve();
    }

    const updatedAccountInfo = {
      ...(contactInfo.businessName ? { Name: contactInfo.businessName } : {}),
    };

    if (_.isEmpty(updatedAccountInfo)) {
      return Promise.resolve();
    }

    // no need to update if the business name is the same
    if (_.get(accountData, ['Name'], '') === contactInfo.businessName) {
      return Promise.resolve();
    }

    return updateAccountAsync({
      ...accountData,
      ...updatedAccountInfo,
    })
      .then(() => {
        setAccountData(prevState => ({
          ...prevState,
          Name: contactInfo.businessName,
        }));
      })
      .catch((error) => {
        throw error;
      });
  }, [accountData, updateAccountAsync]);

  return {
    loadAccountContactInfo,
    updateAccountContactInfo,
  };
};
